import React, { useState } from 'react';
import Button from 'components/styleguide/button/Button';

const styles = require('./eor_advisory.module.scss');

const iconCircleCheck = require('svg/icons-lj-styleguide-2025/circle-check.svg');
const iconExternalLink = require('svg/icons-lj-styleguide-2025/external-link.svg');
const iconClose = require('svg/icons-lj-styleguide-2025/x.svg');

interface EorAdvisoryProps {
  eorLearnMoreUrl?: string;
}

export default function EorAdvisory({ eorLearnMoreUrl = 'https://landing.jobs/business-employer-of-record/' }: EorAdvisoryProps) {
  const [state, setState] = useState<'prompt' | 'confirmed' | 'hidden'>('prompt');

  const handleCalculate = () => {
    document.dispatchEvent(new Event('eor-calculator:open'));
  };

  const handleDismiss = () => {
    setState('confirmed');
  };

  const handleClose = () => {
    setState('hidden');
  };

  if (state === 'hidden') return null;

  if (state === 'confirmed') {
    return (
      <div className={`${styles.advisory} ${styles.advisoryConfirmed}`}>
        <div className={styles.confirmedContent}>
          <img className={styles.checkIcon} src={iconCircleCheck} alt="" width="20" height="20" />
          <span className={styles.confirmedText}>Thank you for your answer!</span>
          <a className={styles.learnLink} href={eorLearnMoreUrl} target="_blank" rel="noopener noreferrer">
            Learn more about EOR
            <img className={styles.externalIcon} src={iconExternalLink} alt="" width="16" height="16" />
          </a>
        </div>
        <button className={styles.closeBtn} onClick={handleClose} aria-label="Dismiss">
          <img src={iconClose} alt="" width="20" height="20" />
        </button>
      </div>
    );
  }

  return (
    <div className={styles.advisory}>
      <p className={styles.text}>Hire globally without opening a local entity. Want us to handle it?</p>
      <div className={styles.actions}>
        <Button context="neutral" type="primary" size="M" onClick={handleCalculate}>
          Yes, calculate costs
        </Button>
        <Button context="neutral" type="secondary" size="M" onClick={handleDismiss}>
          Not now
        </Button>
      </div>
    </div>
  );
}
